import {Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'app-form-input-checkbox',
  templateUrl: './form-input-checkbox.component.html',
  styleUrls: ['./form-input-checkbox.component.sass']
})
export class FormInputCheckboxComponent implements OnInit, OnChanges {

  @Input() name: string = '';
  @Input() label: string = '';
  @Input() error? = false;
  @Input() errorMessage? = '';
  @Input() required = false;
  @Output() onValueChanged = new EventEmitter();
  @Input() formName: FormGroup = new FormGroup<any>({});
  @Input() htmlId: number = Math.floor(Math.random() * (1 + Math.random() * 1000));
  @Input() activated = true;

  ngOnInit() {
    this.updateFormControlState();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['activated']) {
      this.updateFormControlState();
    }
  }

  private updateFormControlState() {
    const ctrl = this.formName.get(this.name);
    if (ctrl) {
      if (this.activated) {
        ctrl.enable({ emitEvent: false });
      } else {
        ctrl.disable({ emitEvent: false });
      }
    }
  }
}
